// src/services/auth.service.js
import { loginApi, logoutApi, getProfileApi } from "../api/auth.api";
import {
  setToken,
  removeToken,
  setUser,
  removeUser,
  getUser,
} from "./storage.service";

export const loginService = async (credentials) => {
  const response = await loginApi(credentials);
  const { token, user } = response.data;

  setToken(token);
  setUser(user);

  return user;
};

export const logoutService = async () => {
  try {
    await logoutApi();
  } catch (e) {
    // ignore API error, still clear local data
  } finally {
    removeToken();
    removeUser();
  }
};

export const getCurrentUserService = async () => {
  // Try local first
  const localUser = getUser();
  if (localUser) return localUser;

  // Fallback to server
  const response = await getProfileApi();
  const user = response.data;
  setUser(user);
  return user;
};
